export const SMART_SEARCH_KEY = 'smartSearch';